import React from "react";
import styled from "styled-components";
import { IBadge } from "../../../commonTypes";
import ArtistOwnerBadgeItem from "./ArtistOwnerBadgeItem";

const Root = styled.div`
  background: ${({ theme }) => theme.backgroundColor};
  border-radius: 10px;
  padding: 20px;
  overflow: hidden;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: -5px;
`;

type Props = {
  badges: IBadge[];
};

const ArtistOwnerBadges = ({ badges }: Props) => {
  return (
    <Root>
      <Container>
        {badges.map((item: IBadge, key: number) => {
          return (
            <ArtistOwnerBadgeItem
              key={key}
              user={item.user}
              title={item.title}
              redirectUrl={item.redirectUrl}
            />
          );
        })}
      </Container>
    </Root>
  );
};

export default ArtistOwnerBadges;
